import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { toast } from 'react-toastify';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';

const MEITubezone = ({
    placeholder,
    className,
    onChange,
    files,
    preview,
    setLoading,
    ...rest
}) => {

    const [tUrls, setTurls] = useState([]);
    useEffect(() => {
        const parsedString = files.replace(/\\"/g, '"');
        const pFiles = parsedString ? JSON.parse(parsedString) : [];
        setTurls(pFiles);
    }, [])
    
    useEffect(() => {
        onChange(tUrls)
    }, [tUrls])


    const handleAddNew = (e) => {
        const newUrl = e.target.value.trim();
        if (newUrl) {
            setTurls((prevurls) => [...prevurls, newUrl])
            e.target.value = '';
        }
        e.preventDefault();
    };


    return (
        <>
            <input id='tzone' className='' style={{ opacity: 0 }} />
            <div className='' style={{ border: '2px dashed var(--falcon-border-color)', borderRadius: '0.25rem', height: '100%', padding: '1rem', textAlign: 'center' }}>

                {placeholder}

                <Row className='border-top mt-2 py-3 d-flex justify-content-betwee row-gap-2 mx-1'>

                    {tUrls.map((file, index) => (
                        <Col md="4" key={index} className='mb-2'>
                            <Form.Group>
                                <FloatingLabel controlId="floatingInput" label={`URL ${index + 1}:`} className="">
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        value={file}
                                        onChange={(e) => {
                                            const updatedUrls = [...tUrls];
                                            const newValue = e.target.value;
                                            if (newValue === '') {
                                                updatedUrls.splice(index, 1)
                                                document.getElementById('tzone').focus()
                                            }
                                            else {
                                                updatedUrls[index] = newValue;
                                            }
                                            setTurls(updatedUrls);
                                        }}
                                    >

                                    </Form.Control>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    ))}




                    <Col md="4">
                        <Form.Group>
                            <FloatingLabel controlId="floatingInput" label="Add New" className="">
                                <Form.Control
                                    type="text"
                                    placeholder=""
                                    onBlur={handleAddNew}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter'){
                                            handleAddNew(e)
                                        }
                                    }}
                                >

                                </Form.Control>
                            </FloatingLabel>
                        </Form.Group>
                    </Col>

                </Row>

            </div>


            {/* <Dropzone
                onDrop={onDrop}
            >
                {({ getRootProps, getInputProps }) => (
                    <div
                        {...getRootProps({
                            className: classNames('dropzone-area', className)
                        })}
                    >
                        <input {...{ ...getInputProps(), ...rest }} />
                        {placeholder}



                        <div className="border-top mt-3 d-flex gap-3">
                            {pFiles.map((file, index) => (
                                <Col md="4" key={index}>
                                    <Form.Group>
                                        <FloatingLabel controlId="floatingInput" label="Sequence Order" className="">
                                            <Form.Control
                                                type="url"
                                                placeholder=""
                                                value={file}
                                            >

                                            </Form.Control>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                            ))}




                            <Col md="4">
                                <Form.Group>
                                    <FloatingLabel controlId="floatingInput" label="Sequence Order" className="">
                                        <Form.Control
                                            type="url"
                                            placeholder=""
                                        >

                                        </Form.Control>
                                    </FloatingLabel>
                                </Form.Group>
                            </Col>

                        </div>

                    </div>
                )}
            </Dropzone> */}
        </>
    )

};

MEITubezone.propTypes = {
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string,
    files: PropTypes.string,
    preview: PropTypes.bool,
    isMulti: PropTypes.bool
};

MEITubezone.defaultProps = {
    placeholder: <img src={cloudUpload} alt="" width={25} className="me-2" />,
    files: '',
    preview: true
};

export default MEITubezone;
